export default {
  'component.tagSelect.expand': 'Rozwiń',
  'component.tagSelect.collapse': 'Zwiń',
  'component.tagSelect.all': 'Wszystkie',
};
